package one.healthium.ui.common.event_producer

import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.update

class EventProducer<Event> {
    private val _events = MutableStateFlow<LinkedHashSet<Event>>(linkedSetOf())
    val events: Flow<Event?> = _events.map { it.firstOrNull() }

    fun trigger(event: Event) {
        _events.update { events ->
            LinkedHashSet(events + event)
        }
    }

    fun consume(event: Event) {
        _events.update { events ->
            LinkedHashSet(events - event)
        }
    }
}
